import React from "react";
import { DragDropContext } from "react-beautiful-dnd";
import { CalendarEditorMonthsHeader, CalendarEditorMonthList } from "./";
import { useForm, FormProvider, useFieldArray } from "react-hook-form";
import { DevTool } from "@hookform/devtools";
import { Button, Tabs, Icon } from "../../../_components";
import { CalendarTimeLabels, CalendarTimeUnit } from "./";
import { useModal, useTime } from "../../../_contexts";
import ReactTooltip from "react-tooltip";
import { parseCalendar } from "../../../_helpers";
import { useDispatch } from "react-redux";
import { CalendarActions } from "../../../_actions";
import { useEventListener } from "../../../_hooks";

const tooltipID = "chronos-calendar-editor-tooltip";
export function CalendarEditor({}) {
  const { calendar, setCalendar } = useTime();
  const { closeModal } = useModal();
  const dispatch = useDispatch();
  const { months, time: timeUnits } = parseCalendar(calendar, "form");
  const { control, ...formMethods } = useForm({
    defaultValues: {
      months: [...months],
      time: { ...timeUnits },
    },
    shouldUnregister: false,
  });

  const {
    fields: formMonths,
    remove: removeMonth,
    append: addMonth,
    move: moveMonth,
    // swap: swapMonth,
  } = useFieldArray({ control, name: `months`, keyName: "rhf_id" });

  const monthList = formMethods.watch("months", formMonths);
  const timeUnitList = formMethods.watch("time");
  const daysInYear = monthList.reduce((t, m) => {
    return (t += m.days);
  }, 0);
  // console.log("TIME UNITS, ", timeUnitList);
  const handleTabChange = () => {
    ReactTooltip.rebuild();
  };
  const handleDragEnd = (result) => {
    const items = Array.from(formMethods.getValues("months"));
    console.log(items);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    formMethods.setValue("months", items);
    return;

    const { destination, source, draggableId, type } = result;

    if (!destination) return;
    if (
      destination.droppableId === source.droppableId &&
      destination.index === source.index
    )
      return;
    // const newMonths = Array.from(months);
    // // console.log('New Months', [...newMonths]);
    // const [movedMonth] = newMonths.splice(source.index, 1);
    // // console.log('New Months', [...newMonths]);
    // newMonths.splice(destination.index, 0, movedMonth);
    // console.log("New Months", [...newMonths]);
    // updateMonths(newMonths);
    moveMonth(source.index, destination.index);
    formMethods.trigger();
    // formMethods.setValue("months", [...newMonths]);

    return;
  };

  const handleClose = () => {
    closeModal();
  };

  const onSubmit = (formData) => {
    // console.log("Form Data: ", formData);
    const parsedFormData = {
      ...calendar,
      ...parseCalendar(formData),
    };
    // console.log("API Data", parsedFormData);
    // parsedFormData.chronicle;
    dispatch(CalendarActions.update(parsedFormData._id, parsedFormData)).then(
      (result) => {
        if (result) {
          // console.log("RESULT", result);
          setCalendar(parsedFormData);
          handleClose();
        }
      }
    );
  };

  const handleKeyClose = (ev) => {
    if (ev.key && ev.key.toLowerCase() === "escape") {
      // console.log("closing form!");
      const { isValidating, isSubmitting, dirtyFields, touched } =
        formMethods.formState;
      if (!isValidating && !isSubmitting) {
        if (
          // formState.dirtyFields &&
          Object.keys(dirtyFields).length === 0 &&
          // formState.touched &&
          Object.keys(touched).length === 0
        ) {
          // console.log("dirty fields!");
          handleClose();
        }
      }
    }
  };

  const handleMonthRemove = (index) => {
    const items = Array.from(formMethods.getValues("months"));
    const newMonths = [
      ...items.slice(0, index),
      ...items.slice(index + 1)
    ];
    formMethods.setValue("months", newMonths);
  }

  const handleMonthAdd = () => {
    const newMonthItem = { name: '', days: 0, displayName: null, leapDays: 0, leapPeriod: 0, order: null};
    addMonth(newMonthItem);
    // const items = Array.from(formMethods.getValues('months'));
    // const newMonths = [
    //   ...items,
    //   newMonthItem,
    // ];
    // formMethods.setValue('months', newMonths);
  }

  useEventListener("keyup", handleKeyClose);

  return (
    <div className="chronos-editor chronos-calendar-editor">
      <FormProvider {...formMethods} control={control}>
        <form
          onSubmit={formMethods.handleSubmit(onSubmit)}
          className="chronos-form"
        >
          <Tabs tabs={["Months", "Time"]} onTabChange={handleTabChange}>
            <div>
              <DragDropContext onDragEnd={handleDragEnd}>
                <CalendarEditorMonthsHeader tooltipContainer={tooltipID} />
                <CalendarEditorMonthList items={monthList} onMonthDelete={handleMonthRemove} />
                <div className="chronos-calendar-month-list-add-btn">
                  <Button onClick={handleMonthAdd} color="primary">
                    <Icon icon="fas fa-plus fa-fw"/>
                    &nbsp;Add Month
                  </Button>
                </div>
              </DragDropContext>
            </div>
            <div>
              <CalendarTimeLabels />
              {Object.keys(timeUnitList).map((unit, index) => (
                <CalendarTimeUnit
                  unitName={unit}
                  key={index}
                  dayCount={daysInYear}
                  tooltipID={tooltipID}
                />
              ))}
            </div>
          </Tabs>
          <div className="form-controls">
            <span>&nbsp;</span>
            <Button color="success" type="submit">
              <Icon icon="fas fa-save fa-fw" />
              &nbsp;Save
            </Button>
          </div>
        </form>
        <DevTool control={control} />
        <ReactTooltip id={tooltipID} effect="solid" />
      </FormProvider>
    </div>
  );
}
